import type { ComponentProps } from 'react';
import { OwcSkeletonLoader } from '@one/react';

export type PocSkeletonLoaderProps = ComponentProps<typeof OwcSkeletonLoader>;

export const PocSkeletonLoader: React.FC<PocSkeletonLoaderProps> = (props) => <OwcSkeletonLoader {...props} />;
